<script setup lang="ts">
import CommonButton from '@/components/common/button/CommonButton.vue'
import MemberManagementTable from '@/components/memberManagement/MemberManagementTable.vue'
import MemberDeleteConfirmDialog from './MemberDeleteConfirmDialog.vue'
import { useMemberPartsCombination } from '@/composables/memberManagement/useMemberPartsCombination'
import MemberRegistrationModal from './MemberRegistrationModal.vue'
import MemberRegistrationSuccessDialog from './MemberRegistrationSuccessDialog.vue'
const { checkedItems, createUser, deleteUser } = useMemberPartsCombination()
</script>

<template>
  <div>
    <div class="d-flex justify-content-end align-items-center">
      <div>
        <CommonButton variant="primary" size="lg" class="fs-5" @click="createUser"
          >新規作成</CommonButton
        >
      </div>
      <div>
        <CommonButton
          variant="outline-primary"
          size="lg"
          class="fs-5 mx-4 delete-button"
          @click="deleteUser"
          :disabled="checkedItems.length === 0"
          >削除</CommonButton
        >
      </div>
    </div>
    <MemberManagementTable
      v-model:checked-items="checkedItems"
      class="mt-4"
    ></MemberManagementTable>
  </div>
  <MemberRegistrationModal ref="memberRegistrationModal"></MemberRegistrationModal>
  <MemberRegistrationSuccessDialog
    ref="memberRegistrationSuccessDialog"
  ></MemberRegistrationSuccessDialog>
  <MemberDeleteConfirmDialog
    :checkedItems="checkedItems"
    ref="memberDeleteConfirmDialog"
  ></MemberDeleteConfirmDialog>
</template>

<style lang="scss" scoped>
.delete-button {
  background-color: #ffffff !important;
}
</style>
